export const PROPERTIES = {
    GROUP_WEB_SIZE: 'GroupWebSize',
    GROUP_WRAPPED: 'GroupWrapped'
};